<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-detail-report-criteria></wbo-detail-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-tax-inclusive-report-criteria
                                    *ngIf="model.data.summary"></wbo-tax-inclusive-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-location-single-select-edit-control [(ngModel)]="model.data.outletGroupId"
                                                                         [allowClearSelectionOption]="false"
                                                                         [formControlName]="'outletGroupId'">
                                </wbo-location-single-select-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
